(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9928],{

/***/ 83518:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



function SvgIconRefresh(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 32,
    height: 32,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M0 0h32v32H0z"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", {
    fill: "#FFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M3.2 16C3.2 8.93 8.93 3.2 16 3.2c4.027 0 7.566 1.862 9.892 4.79l-2.687-.009a1.6 1.6 0 10-.01 3.2l5.509.016c.061.004.123.004.185 0l.706.003A1.6 1.6 0 0031.2 9.6V3.2a1.6 1.6 0 10-3.2 0v2.32C25.1 2.144 20.837 0 16 0 7.163 0 0 7.163 0 16a1.6 1.6 0 103.2 0zM28.8 16c0 7.07-5.73 12.8-12.8 12.8-4.027 0-7.566-1.862-9.892-4.79l2.687.009a1.6 1.6 0 00.01-3.2l-5.509-.016a1.626 1.626 0 00-.185 0l-.706-.003A1.6 1.6 0 00.8 22.4v6.4a1.6 1.6 0 103.2 0v-2.32C6.9 29.856 11.163 32 16 32c8.836 0 16-7.164 16-16a1.6 1.6 0 10-3.2 0z"
  })))));
}

/* harmony default export */ __webpack_exports__["Z"] = (SvgIconRefresh);

/***/ }),

/***/ 50033:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MS": function() { return /* binding */ postBindPhoneApi; },
/* harmony export */   "T9": function() { return /* binding */ modifyApi; },
/* harmony export */   "XB": function() { return /* binding */ logoutApi; },
/* harmony export */   "dE": function() { return /* binding */ postSmsApi; },
/* harmony export */   "k2": function() { return /* binding */ postPhoneLoginApi; },
/* harmony export */   "lx": function() { return /* binding */ loginApi; },
/* harmony export */   "qL": function() { return /* binding */ registerApi; },
/* harmony export */   "t4": function() { return /* binding */ checkWeChatBind; },
/* harmony export */   "vl": function() { return /* binding */ putInformation; },
/* harmony export */   "xp": function() { return /* binding */ forgotApi; },
/* harmony export */   "yd": function() { return /* binding */ getWeChatQrcode; }
/* harmony export */ });
/* unused harmony exports getGoogleLoginToken, checkInviteCode */
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _request__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(84425);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


const loginApi = async params => {
  return _request__WEBPACK_IMPORTED_MODULE_1__/* ["default"].post */ .ZP.post('/users/login', params, {
    skipCodeCheck: true
  });
}; // 退出登陆

const logoutApi = async () => {
  return _request__WEBPACK_IMPORTED_MODULE_1__/* ["default"].post */ .ZP.post('/users/logout');
};
const registerApi = async params => {
  return _request__WEBPACK_IMPORTED_MODULE_1__/* ["default"].post */ .ZP.post('/users/signup', params);
};
const modifyApi = async params => {
  return _request__WEBPACK_IMPORTED_MODULE_1__/* ["default"].post */ .ZP.post('/users/reset-password', params);
}; //发送邮件找回密码

const forgotApi = async params => {
  return _request__WEBPACK_IMPORTED_MODULE_1__/* ["default"].post */ .ZP.post('/users/send-email', params);
}; // 获取token

const getGoogleLoginToken = async _ref => {
  let {
    params
  } = _ref;
  return request.get(`/auth/google/callback`, {
    params
  });
};
const getWeChatQrcode = async () => {
  return _request__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .ZP.get(`/wechat/qrcode`);
}; //引导信息填写

const putInformation = async params => {
  return _request__WEBPACK_IMPORTED_MODULE_1__/* ["default"].put */ .ZP.put(`/users/onboarding`, params);
}; // 查看微信登录状态

const checkWeChatBind = async params => {
  return _request__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .ZP.get(`/wechat/check`, {
    params
  });
}; // 检查邀请码的状态

const checkInviteCode = async _ref2 => {
  let {
    code
  } = _ref2;
  return request.get(`/users/invites/${code}/check`);
}; // 获取短信验证码

const postSmsApi = (data, config) => {
  return _request__WEBPACK_IMPORTED_MODULE_1__/* ["default"].post */ .ZP.post(`/users/send-sms`, _objectSpread(_objectSpread({}, data), config));
}; // 手机号登录

const postPhoneLoginApi = (data, config) => {
  return _request__WEBPACK_IMPORTED_MODULE_1__/* ["default"].post */ .ZP.post(`/users/sms-login`, _objectSpread(_objectSpread({}, data), config));
}; // 绑定手机号

const postBindPhoneApi = (data, config) => {
  return _request__WEBPACK_IMPORTED_MODULE_1__/* ["default"].post */ .ZP.post(`/users/bind-phone`, _objectSpread(_objectSpread({}, data), config));
};

/***/ }),

/***/ 1926:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4730);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _style_index_module_less__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(42258);
/* harmony import */ var _style_index_module_less__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_style_index_module_less__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);


const _excluded = ["value", "onChange"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





function CustomInput(_ref) {
  let {
    value,
    onChange
  } = _ref,
      props = (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_ref, _excluded);

  const {
    0: stateValue,
    1: setValue
  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(value);
  const realValue = value || stateValue || '';
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
    if (value !== stateValue && value === undefined) {
      setValue(value);
    }
  }, [value]);

  const handleChange = newValue => {
    if (!('value' in props)) {
      setValue(newValue);
    } // onChange is passed in by Form.Item and will update the fields bound to the form when triggered.


    onChange && onChange(newValue);
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("input", _objectSpread(_objectSpread({}, props), {}, {
    className: (_style_index_module_less__WEBPACK_IMPORTED_MODULE_4___default().container),
    value: realValue,
    onChange: e => {
      const inputValue = e.target.value;
      handleChange(inputValue); // handleChange({ ...value, input: inputValue })
    }
  }));
}

/* harmony default export */ __webpack_exports__["Z"] = (CustomInput);

/***/ }),

/***/ 92699:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_LanguageSwitch; },
  "Y": function() { return /* binding */ langOptions; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/Select/index.js
var Select = __webpack_require__(94558);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/Message/index.js + 1 modules
var Message = __webpack_require__(80507);
// EXTERNAL MODULE: ./src/context.tsx
var context = __webpack_require__(59544);
// EXTERNAL MODULE: ./src/locale/localeSwitch.ts
var localeSwitch = __webpack_require__(67);
;// CONCATENATED MODULE: ./src/assets/arrow-down-filling.svg
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



function SvgArrowDownFilling(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    width: 12,
    height: 12,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
    d: "M5.65 8.65L1.6 4.6c-.2-.2-.2-.5 0-.7.1-.1.225-.15.35-.15h8.075a.494.494 0 01.35.85L6.35 8.65c-.2.2-.5.2-.7 0z",
    fill: "#FFF",
    fillRule: "nonzero",
    opacity: 0.801
  })));
}

/* harmony default export */ var arrow_down_filling = (SvgArrowDownFilling);
// EXTERNAL MODULE: ./src/utils/language.ts
var language = __webpack_require__(39080);
// EXTERNAL MODULE: ./node_modules/cookies-next/lib/index.js
var lib = __webpack_require__(47041);
// EXTERNAL MODULE: ./src/components/LanguageSwitch/style/index.module.less
var index_module = __webpack_require__(48497);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
// EXTERNAL MODULE: ./src/utils/constants.ts
var constants = __webpack_require__(42586);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/LanguageSwitch/index.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }












const langOptions = [{
  label: 'English',
  value: language/* Language.enUS */.S.enUS,
  englishName: 'english',
  currency: 'USD'
}, {
  label: 'Bahasa Indonesia',
  value: language/* Language.idID */.S.idID,
  englishName: 'indonesian',
  currency: 'IDR'
}, {
  label: '中文',
  value: language/* Language.zhCN */.S.zhCN,
  englishName: 'chinese',
  currency: 'CNY'
}, {
  label: 'ภาษาไทย',
  value: language/* Language.thTH */.S.thTH,
  englishName: 'thai',
  currency: 'THB'
}, {
  label: 'Bahasa Melayu',
  value: language/* Language.msMY */.S.msMY,
  englishName: 'malay',
  currency: 'MYR'
}, {
  label: 'Español',
  value: language/* Language.esES */.S.esES,
  englishName: 'spanish',
  currency: 'EUR'
}];

function LanguageSwitch(_ref) {
  let {
    theme = 'dark',
    getPopupContainer
  } = _ref;
  const {
    lang
  } = (0,react.useContext)(context/* GlobalContext */.kn);
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: classnames_default()((index_module_default()).container, {
      [(index_module_default()).dark]: theme === 'dark',
      [(index_module_default()).light]: theme === 'light'
    }),
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Select/* default */.Z, _objectSpread(_objectSpread({}, theme === 'dark' && {
      arrowIcon: /*#__PURE__*/(0,jsx_runtime.jsx)(arrow_down_filling, {})
    }), {}, {
      options: langOptions,
      value: lang,
      triggerProps: {
        className: (index_module_default()).popup,
        autoAlignPopupWidth: false,
        autoAlignPopupMinWidth: true,
        position: 'br'
      },
      getPopupContainer: getPopupContainer,
      trigger: "hover",
      onChange: value => {
        var _langOptions$find;

        (0,lib.setCookie)(constants/* LANG_COOKIE */.Yk, value, {
          maxAge: constants/* COOKIE_EXPIRE_TIME */.pn
        });
        const nextLang = localeSwitch/* default */.Z[value];
        const curLabel = (_langOptions$find = langOptions.find(item => item.value === value)) === null || _langOptions$find === void 0 ? void 0 : _langOptions$find.label;
        Message/* default.info */.Z.info(`${nextLang['message.lang.tips']}${curLabel}`);
        window.location.reload();
      }
    }))
  });
}

/* harmony default export */ var components_LanguageSwitch = (LanguageSwitch);

/***/ }),

/***/ 48059:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useAfterLogin; }
/* harmony export */ });
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _utils_checkLogin__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23199);
/* harmony import */ var _utils_useStorage__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42644);



// 登陆后处理缓存
function useAfterLogin(_ref) {
  let {
    rememberPassword,
    noRedirect = false
  } = _ref;
  const [loginParams, setLoginParams, removeLoginParams] = (0,_utils_useStorage__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)('loginParams');
  const {
    query
  } = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)();

  function afterLoginSuccess(params, data) {
    var _data$data;

    // 记住密码
    if (rememberPassword) {
      setLoginParams(JSON.stringify(params));
    } else {
      removeLoginParams();
    } // 记录登录状态


    if (data !== null && data !== void 0 && (_data$data = data.data) !== null && _data$data !== void 0 && _data$data.access_token) {
      var _data$data2;

      (0,_utils_checkLogin__WEBPACK_IMPORTED_MODULE_1__/* .setToken */ .o4)(data === null || data === void 0 ? void 0 : (_data$data2 = data.data) === null || _data$data2 === void 0 ? void 0 : _data$data2.access_token);
    }

    if (noRedirect) {
      window.location.reload();
    } else {
      window.location.href = '/board';
    }
  }

  function afterPhoneLoginSuccess(params, data) {
    var _data$data3;

    // 记住密码
    if (rememberPassword) {
      setLoginParams(JSON.stringify(params));
    } else {
      removeLoginParams();
    } // 记录登录状态


    if (data !== null && data !== void 0 && (_data$data3 = data.data) !== null && _data$data3 !== void 0 && _data$data3.access_token) {
      var _data$data4;

      (0,_utils_checkLogin__WEBPACK_IMPORTED_MODULE_1__/* .setToken */ .o4)(data === null || data === void 0 ? void 0 : (_data$data4 = data.data) === null || _data$data4 === void 0 ? void 0 : _data$data4.access_token);
    }

    if (noRedirect) {
      window.location.reload();
    } else {
      window.location.href = '/board';
    }
  }

  return {
    loginParams,
    afterLoginSuccess,
    afterPhoneLoginSuccess
  };
}

/***/ }),

/***/ 74090:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _api_login__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50033);
/* harmony import */ var _useAfterLogin__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(48059);
/* harmony import */ var _useAfterOnboarding__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(30473);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(42586);
/* harmony import */ var _useBdVid__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(63128);
/* harmony import */ var _utils_is__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(1405);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }







 // 表单提交数据登录

const useFormLogin = _ref => {
  let {
    form
  } = _ref;
  const {
    afterLoginSuccess,
    afterPhoneLoginSuccess
  } = (0,_useAfterLogin__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({});
  const {
    afterRegisterSuccess,
    afterPhoneRegisterSuccess
  } = (0,_useAfterOnboarding__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
    rememberPassword: false
  });
  const {
    0: loading,
    1: setLoading
  } = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(false);
  const promotionInfo = (0,_useBdVid__WEBPACK_IMPORTED_MODULE_5__/* .getPromotionInfo */ .yG)(); // 密码

  const onSubmitClick = () => {
    form === null || form === void 0 ? void 0 : form.validate().then(values => {
      setLoading(true);
      (0,_api_login__WEBPACK_IMPORTED_MODULE_1__/* .loginApi */ .lx)(values).then(res => {
        const {
          code
        } = (res === null || res === void 0 ? void 0 : res.data) || {};

        if (code === _utils_constants__WEBPACK_IMPORTED_MODULE_7__/* .SUCCESS_CODE */ .Gh) {
          var _res$data, _res$data$data, _res$data$data$user;

          if ((0,_utils_is__WEBPACK_IMPORTED_MODULE_6__/* .isEmpty */ .xb)(res === null || res === void 0 ? void 0 : (_res$data = res.data) === null || _res$data === void 0 ? void 0 : (_res$data$data = _res$data.data) === null || _res$data$data === void 0 ? void 0 : (_res$data$data$user = _res$data$data.user) === null || _res$data$data$user === void 0 ? void 0 : _res$data$data$user.role)) {
            //没填信息， 注册成功
            afterRegisterSuccess(values, res.data);
          } else {
            //填过信息， 登录成功
            afterLoginSuccess(values, res.data);
          }
        } else {
          console.log(code);
        }
      }).catch(err => {
        var _err$response, _err$response$data;

        // 设置错误信息
        const errors = (err === null || err === void 0 ? void 0 : (_err$response = err.response) === null || _err$response === void 0 ? void 0 : (_err$response$data = _err$response.data) === null || _err$response$data === void 0 ? void 0 : _err$response$data.errors) || {};
        form === null || form === void 0 ? void 0 : form.setFields({
          // 存在则展示，不存在不展示
          email: errors.email ? {
            value: values.email,
            error: {
              message: errors.email
            }
          } : undefined,
          password: errors.password ? {
            value: values.password,
            error: {
              message: errors.password
            }
          } : undefined
        });
      }).finally(() => {
        setLoading(false);
      });
    }).catch(err => {
      console.log('提交err', err);
    });
  };

  const onPhoneSubmitClick = () => {
    form === null || form === void 0 ? void 0 : form.validate().then(values => {
      setLoading(true);

      const params = _objectSpread(_objectSpread({}, values), promotionInfo);

      (0,_api_login__WEBPACK_IMPORTED_MODULE_1__/* .postPhoneLoginApi */ .k2)(params).then(res => {
        const {
          code
        } = (res === null || res === void 0 ? void 0 : res.data) || {};

        if (code === _utils_constants__WEBPACK_IMPORTED_MODULE_7__/* .SUCCESS_CODE */ .Gh) {
          if (!res.data.data.user.role) {
            afterPhoneRegisterSuccess(values, res.data);
          } else {
            afterPhoneLoginSuccess(values, res.data);
          }
        } else {
          console.log(code);
        }
      }).catch(err => {
        var _err$response2, _err$response2$data;

        // 设置错误信息
        const errors = (err === null || err === void 0 ? void 0 : (_err$response2 = err.response) === null || _err$response2 === void 0 ? void 0 : (_err$response2$data = _err$response2.data) === null || _err$response2$data === void 0 ? void 0 : _err$response2$data.errors) || {};
        form === null || form === void 0 ? void 0 : form.setFields({
          // 存在则展示，不存在不展示
          phone: errors.phone ? {
            value: values.phone,
            error: {
              message: errors.phone
            }
          } : undefined,
          code: errors.code ? {
            value: values.code,
            error: {
              message: errors.code
            }
          } : undefined
        });
      }).finally(() => {
        setLoading(false);
      });
    }).catch(err => {
      console.log('提交err', err);
    });
  };

  return {
    onSubmitClick,
    loading,
    onPhoneSubmitClick
  };
};

/* harmony default export */ __webpack_exports__["Z"] = (useFormLogin);

/***/ }),

/***/ 68638:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ usePhoneCaptcha; }
/* harmony export */ });
/* harmony import */ var _api_common__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(74169);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(42586);
/* harmony import */ var _arco_design_web_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(80507);
/* harmony import */ var _utils_useLocale__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83126);
/* harmony import */ var _utils_useLang__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(877);
/* harmony import */ var _utils_index__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1925);






const usePhoneCaptcha = (form, onSuccess) => {
  const t = (0,_utils_useLocale__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)();
  const lang = (0,_utils_useLang__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
  const isChinese = lang === 'zh-CN';

  const handleCaptchaCallback = async res => {
    if (res.ret === 0) {
      var _resData$data;

      const {
        phone
      } = form.getFields();
      const resData = await (0,_api_common__WEBPACK_IMPORTED_MODULE_0__/* .postTencentCaptchaApi */ .Yf)({
        ticket: res.ticket,
        rand_str: res.randstr,
        phone
      });
      (resData === null || resData === void 0 ? void 0 : (_resData$data = resData.data) === null || _resData$data === void 0 ? void 0 : _resData$data.code) === _utils_constants__WEBPACK_IMPORTED_MODULE_4__/* .SUCCESS_CODE */ .Gh && onSuccess();
    }
  };

  const handleLoadError = () => {
    const appid = _utils_constants__WEBPACK_IMPORTED_MODULE_4__/* .TENCENT_APPID */ .gw; // 生成容灾票据或自行做其它处理

    const ticket = 'trerror_1001_' + appid + '_' + Math.floor(new Date().getTime() / 1000);
    handleCaptchaCallback({
      ret: 0,
      randstr: '@' + Math.random().toString(36).substr(2),
      ticket: ticket,
      errorCode: 1001,
      errorMessage: 'jsload_error'
    });
  };

  async function onCaptchaShow() {
    try {
      const {
        phone
      } = form.getFields();

      if (!phone || !_utils_index__WEBPACK_IMPORTED_MODULE_3__/* .phoneReg.test */ .$v.test(phone)) {
        return _arco_design_web_react__WEBPACK_IMPORTED_MODULE_5__/* ["default"].error */ .Z.error(t['login.form.phone.errMsg']);
      } // 生成一个验证码对象
      // CaptchaAppId：登录验证码控制台，从【验证管理】页面进行查看。如果未创建过验证，请先新建验证。注意：不可使用客户端类型为小程序的CaptchaAppId，会导致数据统计错误。
      // callback：定义的回调函数


      const captcha = new TencentCaptcha(_utils_constants__WEBPACK_IMPORTED_MODULE_4__/* .TENCENT_APPID */ .gw, handleCaptchaCallback, {
        userLanguage: isChinese ? 'zh-cn' : 'en'
      }); // 调用方法，显示验证码

      captcha.show();
    } catch (error) {
      console.log('loadErrorCallback回调函数:', error); // 加载异常，调用验证码js加载错误处理函数

      handleLoadError();
    }
  }

  return {
    handleCaptchaCallback,
    handleLoadError,
    onCaptchaShow
  };
};

/***/ }),

/***/ 68275:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42586);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);




const useSetFormInviteCode = _ref => {
  let {
    form
  } = _ref;
  const router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
  const {
    query
  } = router;
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    const curInviteCode = query.f || localStorage.getItem(_utils_constants__WEBPACK_IMPORTED_MODULE_2__/* .INVITE_CODE_STORAGE */ .zX) || '';
    form.setFieldValue('invite_code', curInviteCode);
  }, [query.f, form]);
};

/* harmony default export */ __webpack_exports__["Z"] = (useSetFormInviteCode);

/***/ }),

/***/ 67:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _utils_language__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(39080);

const localeSwitch = {
  [_utils_language__WEBPACK_IMPORTED_MODULE_0__/* .Language.enUS */ .S.enUS]: {
    'message.lang.tips': 'Language switch to '
  },
  [_utils_language__WEBPACK_IMPORTED_MODULE_0__/* .Language.zhCN */ .S.zhCN]: {
    'message.lang.tips': '语言切换至 '
  },
  [_utils_language__WEBPACK_IMPORTED_MODULE_0__/* .Language.idID */ .S.idID]: {
    'message.lang.tips': 'Beralih bahasa ke '
  },
  [_utils_language__WEBPACK_IMPORTED_MODULE_0__/* .Language.thTH */ .S.thTH]: {
    'message.lang.tips': 'การสลับภาษาเป็น'
  },
  [_utils_language__WEBPACK_IMPORTED_MODULE_0__/* .Language.msMY */ .S.msMY]: {
    'message.lang.tips': 'Tukar Bahasa ke '
  },
  [_utils_language__WEBPACK_IMPORTED_MODULE_0__/* .Language.esES */ .S.esES]: {
    'message.lang.tips': 'Cambiar idioma a '
  }
};
/* harmony default export */ __webpack_exports__["Z"] = (localeSwitch);

/***/ }),

/***/ 30567:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var antd_mobile_es_components_dropdown__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(53045);
/* harmony import */ var antd_mobile_es_components_toast__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(13762);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _context__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59544);
/* harmony import */ var _locale_localeSwitch__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67);
/* harmony import */ var cookies_next__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47041);
/* harmony import */ var cookies_next__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(cookies_next__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _index_module_less__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(11678);
/* harmony import */ var _index_module_less__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_index_module_less__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(42586);
/* harmony import */ var _components_LanguageSwitch__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(92699);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85893);











const MobileLangSwitch = _ref => {
  var _langOptions$find2;

  let {
    theme = 'dark'
  } = _ref;
  const {
    lang
  } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_context__WEBPACK_IMPORTED_MODULE_1__/* .GlobalContext */ .kn);

  const handleClick = value => {
    var _langOptions$find;

    (0,cookies_next__WEBPACK_IMPORTED_MODULE_3__.setCookie)(_utils_constants__WEBPACK_IMPORTED_MODULE_6__/* .LANG_COOKIE */ .Yk, value, {
      maxAge: _utils_constants__WEBPACK_IMPORTED_MODULE_6__/* .COOKIE_EXPIRE_TIME */ .pn
    });
    const nextLang = _locale_localeSwitch__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z[value];
    const curLabel = (_langOptions$find = _components_LanguageSwitch__WEBPACK_IMPORTED_MODULE_4__/* .langOptions.find */ .Y.find(item => item.value === value)) === null || _langOptions$find === void 0 ? void 0 : _langOptions$find.label;

    antd_mobile_es_components_toast__WEBPACK_IMPORTED_MODULE_7__/* ["default"].show */ .Z.show({
      content: `${nextLang['message.lang.tips']}${curLabel}`
    });

    window.location.reload();
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("div", {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(antd_mobile_es_components_dropdown__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
      closeOnClickAway: true,
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(antd_mobile_es_components_dropdown__WEBPACK_IMPORTED_MODULE_8__/* ["default"].Item */ .Z.Item, {
        title: (_langOptions$find2 = _components_LanguageSwitch__WEBPACK_IMPORTED_MODULE_4__/* .langOptions.find */ .Y.find(item => item.value === lang)) === null || _langOptions$find2 === void 0 ? void 0 : _langOptions$find2.label,
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("div", {
          className: (_index_module_less__WEBPACK_IMPORTED_MODULE_9___default()["select-list"]),
          children: _components_LanguageSwitch__WEBPACK_IMPORTED_MODULE_4__/* .langOptions.map */ .Y.map((item, index) => {
            return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("div", {
              className: (_index_module_less__WEBPACK_IMPORTED_MODULE_9___default()["select-item"]),
              onClick: () => handleClick(item.value),
              children: item.label
            }, index);
          })
        })
      }, "lang")
    })
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (MobileLangSwitch);

/***/ }),

/***/ 50011:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ PhoneForm; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _arco_design_web_react__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(65976);
/* harmony import */ var _arco_design_web_react__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(80507);
/* harmony import */ var _arco_design_web_react__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(1393);
/* harmony import */ var _arco_design_web_react__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(79458);
/* harmony import */ var _arco_design_web_react__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(32403);
/* harmony import */ var _arco_design_web_react__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(56187);
/* harmony import */ var _arco_design_web_react__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(77303);
/* harmony import */ var _utils_useLocale__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83126);
/* harmony import */ var _utils_useLang__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(877);
/* harmony import */ var _style_phone_login_module_less__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(94914);
/* harmony import */ var _style_phone_login_module_less__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(_style_phone_login_module_less__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _hooks_useFormLogin__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(74090);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1925);
/* harmony import */ var ahooks__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(75697);
/* harmony import */ var _api_login__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(50033);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(42586);
/* harmony import */ var _hooks_useSetFormInviteCode__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(68275);
/* harmony import */ var _hooks_usePhoneCaptcha__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(68638);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(85893);















const initialValues = {
  phone: '',
  code: '',
  invite_code: ''
};
function PhoneForm(_ref) {
  let {
    onChangeForm
  } = _ref;
  const t = (0,_utils_useLocale__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)();
  const [form] = _arco_design_web_react__WEBPACK_IMPORTED_MODULE_10__/* ["default"].useForm */ .Z.useForm();
  const {
    0: targetDate,
    1: setTargetDate
  } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)();
  const [countdown] = (0,ahooks__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({
    targetDate,
    onEnd: () => {// setIsButtonDisabled(false)
    }
  });
  const {
    0: smsBtnLoading,
    1: setSmsBtnLoading
  } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
  const isButtonDisabled = countdown !== 0;
  const router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
  const isLogin = router.pathname.indexOf('/login') > -1;
  const event = isLogin ? 'login' : 'signup';
  const lang = (0,_utils_useLang__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
  const isEnglish = lang === 'en-US'; // let captcha

  const {
    onPhoneSubmitClick,
    loading
  } = (0,_hooks_useFormLogin__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
    form
  });
  (0,_hooks_useSetFormInviteCode__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
    form
  });

  const handleGetCode = async () => {
    try {
      await form.validate(['phone']);
      setSmsBtnLoading(true);
      const {
        phone
      } = form.getFields(); // 发送短信

      (0,_api_login__WEBPACK_IMPORTED_MODULE_6__/* .postSmsApi */ .dE)({
        phone: phone,
        event: event
      }).then(res => {
        var _res$data;

        if ((res === null || res === void 0 ? void 0 : (_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.code) === _utils_constants__WEBPACK_IMPORTED_MODULE_12__/* .SUCCESS_CODE */ .Gh) {
          setTargetDate(Date.now() + 60000);
          _arco_design_web_react__WEBPACK_IMPORTED_MODULE_13__/* ["default"].success */ .Z.success(t['sms_success']);
        } else {
          _arco_design_web_react__WEBPACK_IMPORTED_MODULE_13__/* ["default"].error */ .Z.error(t['sms_error']);
        }
      }).finally(() => {
        setSmsBtnLoading(false);
      });
    } catch (e) {
      console.log('catch phone error:', e);
      return;
    }
  };

  const {
    onCaptchaShow
  } = (0,_hooks_usePhoneCaptcha__WEBPACK_IMPORTED_MODULE_8__/* .usePhoneCaptcha */ .i)(form, handleGetCode);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
    className: (_style_phone_login_module_less__WEBPACK_IMPORTED_MODULE_14___default()["login-form-wrapper"]),
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)(_arco_design_web_react__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
      form: form,
      className: (_style_phone_login_module_less__WEBPACK_IMPORTED_MODULE_14___default()["login-form"]),
      layout: "vertical",
      initialValues: initialValues,
      size: "large",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(_arco_design_web_react__WEBPACK_IMPORTED_MODULE_10__/* ["default"].Item */ .Z.Item, {
        label: t['phone_number'],
        field: "phone",
        validateTrigger: ['onFinish'],
        rules: [{
          required: true,
          validator: _utils__WEBPACK_IMPORTED_MODULE_5__/* .phoneFormValidator */ .ht,
          message: t['login.form.phone.errMsg']
        }],
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(_arco_design_web_react__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
          size: "large",
          className: (_style_phone_login_module_less__WEBPACK_IMPORTED_MODULE_14___default().customInput),
          addBefore: "+86",
          placeholder: t['phone_number']
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(_arco_design_web_react__WEBPACK_IMPORTED_MODULE_10__/* ["default"].Item */ .Z.Item, {
        label: t['verification_code'],
        required: true,
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)(_arco_design_web_react__WEBPACK_IMPORTED_MODULE_16__/* ["default"].Row */ .Z.Row, {
          align: "center",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(_arco_design_web_react__WEBPACK_IMPORTED_MODULE_10__/* ["default"].Item */ .Z.Item, {
            noStyle: {
              showErrorTip: true
            },
            field: "code",
            rules: [{
              required: true,
              message: t['code_errMsg']
            }],
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(_arco_design_web_react__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
              size: "large",
              className: (_style_phone_login_module_less__WEBPACK_IMPORTED_MODULE_14___default().customInput),
              hideControl: true,
              placeholder: t['verification_code'],
              min: 0,
              style: {
                flex: 1
              }
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(_arco_design_web_react__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
            type: "primary",
            id: "captcha-button",
            onClick: onCaptchaShow,
            className: "captcha-btn",
            disabled: isButtonDisabled || smsBtnLoading,
            style: {
              height: 48
            },
            children: isButtonDisabled ? `${Math.round(countdown / 1000)}s ${t['get_verification_code']}` : t['get_verification_code']
          })]
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(_arco_design_web_react__WEBPACK_IMPORTED_MODULE_10__/* ["default"].Item */ .Z.Item, {
        label: t['register.form.invite.label'],
        field: "invite_code",
        validateTrigger: ['onFinish'] // rules={[{ required: true, validator: phoneFormValidator, message: t['login.form.phone.errMsg'] }]}
        ,
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(_arco_design_web_react__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
          size: "large",
          className: (_style_phone_login_module_less__WEBPACK_IMPORTED_MODULE_14___default().customInput),
          placeholder: t['register.form.invite.placeholder']
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)(_arco_design_web_react__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
        size: 16,
        direction: "vertical",
        children: [isLogin ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("span", {
          className: (_style_phone_login_module_less__WEBPACK_IMPORTED_MODULE_14___default().emailLogin),
          onClick: () => onChangeForm === null || onChangeForm === void 0 ? void 0 : onChangeForm('email'),
          children: t['email_login']
        }) : isEnglish ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("span", {
          className: (_style_phone_login_module_less__WEBPACK_IMPORTED_MODULE_14___default().emailLogin),
          onClick: () => onChangeForm === null || onChangeForm === void 0 ? void 0 : onChangeForm('email'),
          children: t['email_register']
        }) : null, /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(_arco_design_web_react__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
          type: "primary",
          long: true,
          onClick: onPhoneSubmitClick,
          loading: loading,
          size: "large",
          className: (_style_phone_login_module_less__WEBPACK_IMPORTED_MODULE_14___default()["login-form-btn"]),
          style: {
            height: 48,
            borderRadius: 8
          },
          children: t['login_register']
        })]
      })]
    })
  });
}

/***/ }),

/***/ 58089:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ WeChatLogin; }
/* harmony export */ });
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _api_login__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50033);
/* harmony import */ var _hooks_useAfterLogin__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(48059);
/* harmony import */ var _hooks_useAfterOnboarding__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(30473);
/* harmony import */ var _arco_design_web_react__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(80507);
/* harmony import */ var _arco_design_web_react__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(62258);
/* harmony import */ var _arco_design_web_react__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(56187);
/* harmony import */ var _assets_icon_refresh_svg__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(83518);
/* harmony import */ var _arco_design_web_react_icon__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(42355);
/* harmony import */ var _arco_design_web_react_icon__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(81025);
/* harmony import */ var _utils_useLang__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(877);
/* harmony import */ var _utils_useLocale__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(83126);
/* harmony import */ var _style_wechat_login_module_less__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(62879);
/* harmony import */ var _style_wechat_login_module_less__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(_style_wechat_login_module_less__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _utils_checkLogin__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(23199);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(1925);
/* harmony import */ var _hooks_useBdVid__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(63128);
/* harmony import */ var _utils_gtagEvent__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(73491);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(85893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


















function WeChatLogin(props) {
  var _router$query;

  const router = (0,next_router__WEBPACK_IMPORTED_MODULE_8__.useRouter)();
  const initQrcodeUrl = ((_router$query = router.query) === null || _router$query === void 0 ? void 0 : _router$query.qrcodeUrl) || '';
  const {
    qhclickid
  } = (0,_hooks_useBdVid__WEBPACK_IMPORTED_MODULE_11__/* .getBdVid */ .Wu)();
  const promotionInfo = (0,_hooks_useBdVid__WEBPACK_IMPORTED_MODULE_11__/* .getPromotionInfo */ .yG)();
  const {
    type,
    step,
    setStep,
    sessionFlag,
    setSessionFlag,
    inviteCode,
    setShowWechat
  } = props;
  const {
    0: qrcodeUrl,
    1: setQrcodeUrl
  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(initQrcodeUrl); // const [sessionFlag, setSessionFlag] = useState('')

  const {
    0: isExpire,
    1: setIsExpire
  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
  const {
    0: isLoading,
    1: setIsLoading
  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
  const {
    0: isAgree,
    1: setIsAgree
  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
  const lang = (0,_utils_useLang__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)();
  const t = (0,_utils_useLocale__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)();
  const checkId = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
  const {
    afterLoginSuccess
  } = (0,_hooks_useAfterLogin__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
    rememberPassword: false
  });
  const {
    afterRegisterSuccess
  } = (0,_hooks_useAfterOnboarding__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
    rememberPassword: false
  });

  const fetchQrcode = async () => {
    var _res$data;

    setIsLoading(true);
    const res = await (0,_api_login__WEBPACK_IMPORTED_MODULE_2__/* .getWeChatQrcode */ .yd)();

    if (res !== null && res !== void 0 && (_res$data = res.data) !== null && _res$data !== void 0 && _res$data.data) {
      var _res$data2;

      const {
        session_flag,
        url
      } = (res === null || res === void 0 ? void 0 : (_res$data2 = res.data) === null || _res$data2 === void 0 ? void 0 : _res$data2.data) || {};
      url && setQrcodeUrl(url);
      session_flag && setSessionFlag(session_flag);
      setTimeout(() => {
        setIsExpire(true);
        checkId.current && clearInterval(checkId.current);
      }, 300000);
    }

    setIsLoading(false);
  };

  const checkBind = async () => {
    var _res$data3, _res$data3$data;

    const res = await (0,_api_login__WEBPACK_IMPORTED_MODULE_2__/* .checkWeChatBind */ .t4)(_objectSpread(_objectSpread({
      session_flag: sessionFlag,
      invite_code: inviteCode
    }, promotionInfo), {}, {
      debug: true
    }));

    if (res !== null && res !== void 0 && (_res$data3 = res.data) !== null && _res$data3 !== void 0 && (_res$data3$data = _res$data3.data) !== null && _res$data3$data !== void 0 && _res$data3$data.access_token) {
      var _res$data4, _res$data4$data, _res$data5, _res$data5$data, _res$data5$data$user, _res$data6, _res$data6$data, _res$data6$data$user;

      // 登录成功
      (0,_utils_checkLogin__WEBPACK_IMPORTED_MODULE_9__/* .clearInviteCode */ .E$)();
      checkId.current && clearInterval(checkId.current);

      if ((res === null || res === void 0 ? void 0 : (_res$data4 = res.data) === null || _res$data4 === void 0 ? void 0 : (_res$data4$data = _res$data4.data) === null || _res$data4$data === void 0 ? void 0 : _res$data4$data.event_type) === 'signup') {
        (0,_utils__WEBPACK_IMPORTED_MODULE_10__/* .baiduRegisterEvent */ .Rk)(); // qhTrackRegister({
        //   qhclickid,
        //   id: res?.data?.data?.user?.user_id
        // })

        (0,_utils_gtagEvent__WEBPACK_IMPORTED_MODULE_13__/* .gtagRegisterEvent */ .IQ)();
      }

      if ((res === null || res === void 0 ? void 0 : (_res$data5 = res.data) === null || _res$data5 === void 0 ? void 0 : (_res$data5$data = _res$data5.data) === null || _res$data5$data === void 0 ? void 0 : (_res$data5$data$user = _res$data5$data.user) === null || _res$data5$data$user === void 0 ? void 0 : _res$data5$data$user.region) === null || (res === null || res === void 0 ? void 0 : (_res$data6 = res.data) === null || _res$data6 === void 0 ? void 0 : (_res$data6$data = _res$data6.data) === null || _res$data6$data === void 0 ? void 0 : (_res$data6$data$user = _res$data6$data.user) === null || _res$data6$data$user === void 0 ? void 0 : _res$data6$data$user.region) === null) {
        afterRegisterSuccess('', res === null || res === void 0 ? void 0 : res.data);
      } else {
        _arco_design_web_react__WEBPACK_IMPORTED_MODULE_14__/* ["default"].success */ .Z.success(t['login.wechat.success']);
        afterLoginSuccess({}, res === null || res === void 0 ? void 0 : res.data);
      }
    }
  };

  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
    if (step === '') {
      fetchQrcode();
    }
  }, []);
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
    if (qrcodeUrl && sessionFlag) {
      checkId.current = setInterval(checkBind, 3000);
    }

    return () => {
      checkId.current && clearInterval(checkId.current);
    };
  }, [qrcodeUrl, sessionFlag]);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsxs)("div", {
    className: (_style_wechat_login_module_less__WEBPACK_IMPORTED_MODULE_15___default().container),
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)("div", {
      className: (_style_wechat_login_module_less__WEBPACK_IMPORTED_MODULE_15___default().back),
      onClick: () => {
        setShowWechat(false);
      },
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(_arco_design_web_react_icon__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {})
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsxs)("div", {
      className: (_style_wechat_login_module_less__WEBPACK_IMPORTED_MODULE_15___default().content),
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)("div", {
        className: (_style_wechat_login_module_less__WEBPACK_IMPORTED_MODULE_15___default().title),
        children: t['login.form.title']
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsxs)(_arco_design_web_react__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
        loading: isLoading,
        children: [isExpire && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)("div", {
          className: (_style_wechat_login_module_less__WEBPACK_IMPORTED_MODULE_15___default()["expire-wrap"]),
          onClick: () => {
            fetchQrcode();
            setIsExpire(false);
          },
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsxs)("div", {
            className: (_style_wechat_login_module_less__WEBPACK_IMPORTED_MODULE_15___default().expire),
            children: ["\u4E8C\u7EF4\u7801\u5DF2\u5931\u6548", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(_assets_icon_refresh_svg__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
              className: (_style_wechat_login_module_less__WEBPACK_IMPORTED_MODULE_15___default().refresh)
            })]
          })
        }), step === 'complete' && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsxs)("div", {
          className: (_style_wechat_login_module_less__WEBPACK_IMPORTED_MODULE_15___default().next),
          children: ["\u5FAE\u4FE1\u5DF2\u7ED1\u5B9A", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(_arco_design_web_react__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
            onClick: () => {
              if (!isAgree) {
                _arco_design_web_react__WEBPACK_IMPORTED_MODULE_14__/* ["default"].error */ .Z.error('请先阅读并同意服务协议和隐私协议！');
                return;
              } // 不再校验验证码
              // if (!isEffective) {
              //   Message.error('请输入有效的邀请码！')
              //   return
              // }


              setStep('fulfill');
            },
            className: (_style_wechat_login_module_less__WEBPACK_IMPORTED_MODULE_15___default()["next-btn"]),
            children: "\u4E0B\u4E00\u6B65"
          })]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)("div", {
          style: {
            width: '258px',
            height: '258px'
          },
          children: qrcodeUrl && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)("img", {
            src: qrcodeUrl,
            className: (_style_wechat_login_module_less__WEBPACK_IMPORTED_MODULE_15___default().qrcode)
          })
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsxs)("div", {
        style: {
          display: 'flex',
          alignItems: 'center',
          marginTop: '48px'
        },
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)("div", {
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(_arco_design_web_react_icon__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
            style: {
              color: '#00C800',
              marginRight: '10px',
              width: '16px',
              height: '16px'
            }
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)("div", {
          style: {
            color: '#403D5A'
          },
          children: type === 'register' ? t['register.wechat.scan'] : t['login.wechat.scan']
        })]
      }), type === 'register' && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)("div", {
        style: {
          marginTop: '32px'
        },
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsxs)("span", {
          className: (_style_wechat_login_module_less__WEBPACK_IMPORTED_MODULE_15___default()["checkbox-text"]),
          children: [t['register.scan.tip'], /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)("a", {
            href: "https://echotik.live/privacy-policy.html",
            target: "_blank",
            rel: "noreferrer",
            className: (_style_wechat_login_module_less__WEBPACK_IMPORTED_MODULE_15___default()["checkbox-protocol"]),
            children: t['register.service.term']
          }), t['register.and'], /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)("a", {
            href: "https://echotik.live/privacy-policy.html",
            target: "_blank",
            rel: "noreferrer",
            className: (_style_wechat_login_module_less__WEBPACK_IMPORTED_MODULE_15___default()["checkbox-protocol"]),
            children: t['register.privacy.policy']
          })]
        })
      })]
    })]
  });
}

/***/ }),

/***/ 88848:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _arco_design_web_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(56187);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);





function LoginBtn(_ref) {
  let {
    icon,
    text,
    onClick
  } = _ref;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_arco_design_web_react__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
      onClick: onClick,
      style: {
        width: '100%',
        height: '48px',
        borderRadius: '8px',
        backgroundColor: '#fff',
        border: '1px solid #888BA6',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        fontSize: '16px'
      },
      children: [icon, text]
    })
  });
}

/* harmony default export */ __webpack_exports__["Z"] = (LoginBtn);

/***/ }),

/***/ 73491:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "IQ": function() { return /* binding */ gtagRegisterEvent; },
/* harmony export */   "Tz": function() { return /* binding */ gtagInitiateCheckoutEvent; },
/* harmony export */   "_L": function() { return /* binding */ gtagPurchaseEvent; },
/* harmony export */   "dv": function() { return /* binding */ gtagUpgradeIconEvent; }
/* harmony export */ });
const gtagRegisterEvent = () => {
  var _window, _window$gtag;

  (_window = window) === null || _window === void 0 ? void 0 : (_window$gtag = _window.gtag) === null || _window$gtag === void 0 ? void 0 : _window$gtag.call(_window, 'event', 'register', {
    entry: 'board'
  });
}; // 点击升级按钮

const gtagUpgradeIconEvent = () => {
  var _window2, _window2$gtag;

  (_window2 = window) === null || _window2 === void 0 ? void 0 : (_window2$gtag = _window2.gtag) === null || _window2$gtag === void 0 ? void 0 : _window2$gtag.call(_window2, 'event', 'upgrade_icon_click', {
    entry: 'board'
  });
}; // 点击弹窗中的立即购买按钮

const gtagInitiateCheckoutEvent = () => {
  var _window3, _window3$gtag;

  (_window3 = window) === null || _window3 === void 0 ? void 0 : (_window3$gtag = _window3.gtag) === null || _window3$gtag === void 0 ? void 0 : _window3$gtag.call(_window3, 'event', 'initiate_checkout', {
    entry: 'board'
  });
};
const gtagPurchaseEvent = _ref => {
  var _window4, _window4$gtag;

  let {
    sku,
    currency,
    total_amount
  } = _ref;
  console.log('gtagPurchaseEvent', sku, currency, total_amount);
  (_window4 = window) === null || _window4 === void 0 ? void 0 : (_window4$gtag = _window4.gtag) === null || _window4$gtag === void 0 ? void 0 : _window4$gtag.call(_window4, 'event', 'purchase', {
    entry: 'board',
    sku,
    currency,
    total_amount
  });
};

/***/ }),

/***/ 1925:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$v": function() { return /* binding */ phoneReg; },
/* harmony export */   "GH": function() { return /* binding */ addEnhancedConversion; },
/* harmony export */   "H0": function() { return /* binding */ formatNumberWithUnits; },
/* harmony export */   "Rk": function() { return /* binding */ baiduRegisterEvent; },
/* harmony export */   "ht": function() { return /* binding */ phoneFormValidator; },
/* harmony export */   "m0": function() { return /* binding */ emailReg; },
/* harmony export */   "mf": function() { return /* binding */ splitStringByNewline; },
/* harmony export */   "ql": function() { return /* binding */ emailFormValidator; },
/* harmony export */   "yK": function() { return /* binding */ formatDigital; },
/* harmony export */   "zp": function() { return /* binding */ copyText; }
/* harmony export */ });
/* unused harmony exports formatLocaleString, getFillCoverUrl */
/* harmony import */ var lodash_isNumber__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(81763);
/* harmony import */ var lodash_isNumber__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_isNumber__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _is__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1405);



function formatNumber(value) {
  if (value / 1000 / 1000 / 1000 >= 1) {
    return [(value / 1000 / 1000 / 1000).toFixed(1), 'B'];
  } else if (value / 1000 / 1000 >= 1) {
    return [(value / 1000 / 1000).toFixed(1), 'M'];
  } else if (value / 1000 >= 1) {
    return [(value / 1000).toFixed(1), 'K'];
  } else {
    // 没有小数位，直接返回
    if (value === Number(value.toFixed(0))) {
      return [value, ''];
    }

    return [value.toFixed(1), ''];
  }
}

function formatDigital(value) {
  if (!value) return [value, ''];

  if (typeof value === 'number') {
    return formatNumber(value);
  } else {
    return [value, ''];
  }
}
function formatLocaleString(num) {
  return (+num || 0).toLocaleString();
} // 复制文本到剪贴板

function copyText(text) {
  var _navigator;

  if ((_navigator = navigator) !== null && _navigator !== void 0 && _navigator.clipboard) {
    var _navigator$clipboard$, _navigator$clipboard;

    (_navigator$clipboard$ = (_navigator$clipboard = navigator.clipboard).writeText) === null || _navigator$clipboard$ === void 0 ? void 0 : _navigator$clipboard$.call(_navigator$clipboard, text);
  } else {
    // 创建输入框
    const textarea = document.createElement('textarea');
    document.body.appendChild(textarea); // 隐藏此输入框

    textarea.style.position = 'absolute';
    textarea.style.clip = 'rect(0 0 0 0)'; // 赋值

    textarea.value = text; // 选中

    textarea.select(); // 复制

    document.execCommand('copy', true);
  }
}
function addEnhancedConversion(email) {
  try {
    window.enhanced_conversion_data = {
      email
    };
    window.gtag('event', 'conversion', {
      send_to: 'AW-11015810512/kiupCKGh6oAYENDb34Qp',
      value: 1.0,
      currency: 'USD'
    });
  } catch (error) {
    console.log(error);
  }
} // 拼接带有压缩参数和裁剪参数的图片url

const getFillCoverUrl = (url, fillParams) => {
  if (!url) return '';

  if (isBlurValue(url)) {
    return url;
  } else if (url.includes('?')) {
    const splitUrls = url.split('?');
    return `${splitUrls[0]}${fillParams}?${splitUrls[1]}`;
  } else {
    return `${url}${fillParams}`;
  }
};
function splitStringByNewline(str) {
  const array = str.split(/[\r\n]+/);
  return array.filter(i => i !== '');
}
const emailReg = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
const emailFormValidator = (value, callback) => {
  // 使用正则校验邮箱
  if (!value || !emailReg.test(value)) {
    callback(true);
  }
};
const phoneReg = /^1\d{10}$/;
const phoneFormValidator = (value, callback) => {
  // 使用正则校验手机号
  if (!value || !phoneReg.test(value)) {
    callback(true);
  }
}; // 上报注册成功百度营销事件

function baiduRegisterEvent() {
  window._agl && window._agl.push(['track', ['success', {
    t: 3
  }]]);
}
function formatNumberWithUnits(num) {
  if (lodash_isNumber__WEBPACK_IMPORTED_MODULE_0___default()(num)) {
    if (num < 1000) {
      return `${num}`;
    }

    const units = ['K', 'M', 'B'];
    let unitIndex = -1;
    let formattedNum = num;

    while (formattedNum >= 1000 && unitIndex < units.length - 1) {
      formattedNum /= 1000;
      unitIndex++;
    }

    return `${formattedNum.toFixed(2)}${units[unitIndex]}`;
  }

  return num;
}

/***/ }),

/***/ 877:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _context__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59544);


/**
 * 获取language
 */

function useLang() {
  const {
    lang
  } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_context__WEBPACK_IMPORTED_MODULE_1__/* .GlobalContext */ .kn);
  return lang;
}

/* harmony default export */ __webpack_exports__["Z"] = (useLang);

/***/ }),

/***/ 42258:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"index_container__EuV3O"};

/***/ }),

/***/ 48497:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"width-limit":"index_width-limit__SFlgU","overflow-hidden":"index_overflow-hidden__7hcMk","dark":"index_dark__oCx5W","light":"index_light__fPqlf","popup":"index_popup__xrOBg"};

/***/ }),

/***/ 11678:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"select-list":"index_select-list__0idW5","select-item":"index_select-item__JtJsD"};

/***/ }),

/***/ 94914:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"customInput":"phone-login_customInput__qf2pt","emailLogin":"phone-login_emailLogin__CuI90"};

/***/ }),

/***/ 62879:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"wechat-login_container__ufNLu","back":"wechat-login_back__79bmk","title":"wechat-login_title__jr2ag","content":"wechat-login_content__UnsYN","next":"wechat-login_next__xig_D","next-btn":"wechat-login_next-btn__o7Cue","expire-wrap":"wechat-login_expire-wrap__xXR3a","expire":"wechat-login_expire__yNsZ_","refresh":"wechat-login_refresh__PfO02","qrcode":"wechat-login_qrcode__rihae","logo":"wechat-login_logo___TBeM","checkbox":"wechat-login_checkbox__ozjJ2","checkbox-text":"wechat-login_checkbox-text__VTYQZ","checkbox-protocol":"wechat-login_checkbox-protocol__Y36Q_"};

/***/ })

}]);